<template>
    <Path>
        <template v-slot:path>
            <li>
                <router-link :to="{ name: 'dashboard' }">الصفحة الرئيسية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#services"
                    @click="$router.push({ name: 'dashboard' })">الخدمات
                </a> </li>
            <li> <span class="divider"> / </span>
                <router-link :to="{ name: 'electronicservices' }">الخدمات الالكترونية</router-link>
            </li>
            <li> <span class="divider"> / </span><a href="#">استخراج قسيمة زواج </a> </li>
        </template>
    </Path>

    <section v-if="!isReview" id="content">
        <div class="py-5 ">
            <div class="container">
                <div class="row">
                    <div class="col-12 mb-2">
                        <h2 class="blueFont ">الطلب {{ docRequests.totalRequests }} / {{ docRequests.requestNo }} قسيمة
                            زواج
                        </h2>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="basic-url" class="form-label">الاسم رباعي لصاحب القسيمة</label>
                        <div class="input-group mb-3">
                            <div class="row g-3">
                                <div class="col-6 col-sm">
                                    <input v-model="form.firstName" type="text" class="form-control" id="basic-url1"
                                        aria-describedby="basic-addon3" @blur="v$.form.firstName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.firstName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.secondName" type="text" class="form-control" id="basic-url2"
                                        aria-describedby="basic-addon3" @blur="v$.form.secondName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.secondName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.thirdName" type="text" class="form-control" id="basic-url3"
                                        aria-describedby="basic-addon3" @blur="v$.form.thirdName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.thirdName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                                <div class="col-6 col-sm">
                                    <input v-model="form.fourthName" type="text" class="form-control" id="basic-ur4l"
                                        aria-describedby="basic-addon3" @blur="v$.form.fourthName.$touch()">
                                    <p class="data--required" v-for="error of v$.form.fourthName.$errors"
                                        :key="error.$uid">
                                        {{ error.$message }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <label for="basic-url" class="form-label">الرقم القومى لصاحب القسيمة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.nid" type="text" class="form-control" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.nid.$touch()">
                                <p class="data--required" v-for="error of v$.form.nid.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">النوع</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="gender" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.gender.$touch()">
                                    <option v-for="gender in gender_lookups" :key="gender.Id" :value="gender.Code">
                                        {{ gender.Name }}</option>
                                </select>
                                <p class="data--required" v-for="error of v$.gender.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>

                    <div class="col-md-6">
                        <label for="" class="form-label">صلة القرابة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <select v-model="form.relationCode" class="form-select" id="basic-url1"
                                    aria-describedby="basic-addon3" @blur="v$.form.relationCode.$touch()">
                                    <option v-for="relation in relation_lookups" :key="relation.Id"
                                        :value="relation.Code">
                                        {{ relation.Name }}</option>
                                </select>
                                <p class="data--required" v-for="error of v$.form.relationCode.$errors"
                                    :key="error.$uid">
                                    {{ error.$message }}
                                </p>

                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-6">
                        <label for="" class="form-label">اسم الام بالكامل لصاحب القسيمة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.motherName" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.motherName.$touch()">
                                <p class="data--required" v-for="error of v$.form.motherName.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>


                        </div>
                    </div>

                    <div v-if="gender" class="col-md-6">
                        <label for="" class="form-label">اسم {{spouseGender}} بالكامل لصاحب القسيمة</label>
                        <div class="input-group mb-3">
                            <div class="col-md-12">
                                <input v-model="form.spouseName" type="text" class="form-control " id="basic-ur4l"
                                    aria-describedby="basic-addon3" @blur="v$.form.spouseName.$touch()">
                                <p class="data--required" v-for="error of v$.form.spouseName.$errors" :key="error.$uid">
                                    {{ error.$message }}
                                </p>
                            </div>

                        </div>
                    </div>

                </div>

                <div class="row mb-3">
                    <div class="col-6 col-md-2">
                        <label for="" class="form-label mb-3">عدد النسخ</label>
                    </div>
                    <div class="col-6 col-md-4  mb-3 counter_input">
                        <button @click="copies++" type="button" class="pa-0  ma-0 icon-btn"><i
                                class="bi bi-plus-circle"></i></button>
                        <input v-model="copies" type="text" class="form-control  text-center" aria-label="">
                        <button @click="copies--" type="button" class="pa-0 ma-0 icon-btn"><i
                                class="bi bi-dash-circle"></i></button>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                        <label for="" class="form-label">اجمالى سعر الخدمة</label>
                    </div>
                    <div class="col-6 col-md-3 mb-3">
                        <input v-model="totalPrice" type="text" readonly="readonly" class="form-control text-center"
                            aria-label="">
                    </div>
                </div>

                <div class="row">
                    <div class="row my-5 justify-content-center">

                        <div :hidden="docRequests.requestNo === 1" class="col-6 col-sm-2 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="previousDoc" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    القسيمة السابقة
                                </button>
                            </div>
                        </div>
                        <div :hidden="docRequests.totalRequests === docRequests.requestNo" class="col-6 col-sm-2 mx-5 mb-3 ">
                            <div class="d-flex justify-content-center">
                                <button @click="nextDoc" type="button" class="btn1 btn-light mx-3 align-self-center">
                                    القسيمة التالية
                                </button>
                            </div>
                        </div>
                        <div :hidden="docRequests.totalRequests !== docRequests.requestNo" class="col-6 col-sm-2 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="addMarriageDoc" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    إضافة قسيمة
                                </button>
                            </div>
                        </div>

                        <div :hidden="docRequests.requestNo === 1" class="col-6 col-sm-2 mx-5 mb-3">
                            <div class="d-flex justify-content-center">
                                <button @click="deleteDocument" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    حذف قسيمة
                                </button>
                            </div>
                        </div>

                        <div class="col-6 col-sm-2 mx-5 mb-3 ">
                            <div class="d-flex justify-content-center">
                                <button @click="review_request" type="button"
                                    class="btn1 btn-light mx-3 align-self-center">
                                    مراجعة الطلب
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <Review v-if="isReview" @close="toggle_isReview()" :serviceprice="price" :DocCode="MarriageCode" DocType=" زواج"
        :DocData="DocData" :isNid="false" />

</template>


<script>
import validations from "@/shared/validations.js";
import sharedMethods from "@/shared/sharedMethods";
import { mapActions, mapGetters } from "vuex";
import useVuelidate from "@vuelidate/core";
import Path from "@/components/Path.vue";
import Review from "@/components/Review.vue";
import { ref } from 'vue';
import sharedData from '@/shared/sharedData';
import { debugLog } from "@/plugins/debug";

export default {
    ...sharedMethods,
    name: 'MarriageView',
    components: { Path, Review },
    data() {
        return {

            v$: useVuelidate(),

            valid: false,
            count: 0,
            docsCount: 1,

            responseMessage: '',
            responseCode: 200,

            spouseGender:"",

            price: 0,
            totalPrice: 0,

            // # document requests
            docRequests: {
                requestNo: 1,
                totalRequests: 1
            },

            relation_lookups: [],
            gender_lookups: [],
            gender: '',
            copies: 1,
            MarriageCode: sharedData.DocumentsCode.MarriageCode,

            form: {
                firstName: '',
                secondName: '',
                thirdName: '',
                fourthName: '',
                nid: '',
                motherName: '',
                spouseName: '',
                relationCode: ''
            },
        }
    },
    setup() {
        const isReview = ref(false);
        const toggle_isReview = () => {
            isReview.value = !isReview.value;

        }
        return { isReview, toggle_isReview }
    },

    // validations
    validations() {
        return validations.Marriage
    },

    created() {
        // reset after refersh or reloading page
        this.resetDocs();  // store action for resetting number of documents in store to 0
        this.docRequests.requestNo = 1;
        setTimeout(() => {
            sharedMethods.get_servicePrice("marriagePrice").then(res => { this.price = res; this.totalPrice = res; });
            sharedMethods.get_genders().then(res => { this.gender_lookups = res; });
        }, 200);
        
        window.scrollTo({ top: 0, behavior: "smooth" });
        //   this.AutoFill();
    },
    watch: {
        // whenever gender changes, this function will run
        gender(newGender) {
            if (newGender) {
                sharedMethods.get_relations(this.MarriageCode, this.gender).then(res => { this.relation_lookups = res; });
                if(this.gender === 'M'){this.spouseGender = 'الزوجة';}
                if(this.gender === 'F'){this.spouseGender = 'الزوج';}
            }
        },
        copies(newCopy) {
            this.totalPrice = this.price * newCopy;
            if (newCopy > 5) {
                this.copies = 5;
            }
            if (newCopy <= 1) {
                this.copies = 1;
            }
        },
    },

    computed: {
        ...mapGetters({ MarriageDocs: "StateDocs", options: "StateOptions", contactInfo: "StateContact" }),

        DocData() {
            return {
                "marriageDocs": Object.values(this.MarriageDocs),
                ...this.contactInfo
            }
        }
    },

    methods: {
        ...mapActions(["saveDocs", "resetDocs", "deleteDoc"]),

        async review_request() {
            this.v$.$validate();

            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store                      
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });
                if (this.responseCode === 200) {

                    debugLog('Docs:', Object.values(this.MarriageDocs));
                    this.isReview = true;
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }

            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // add new marriage document
        async addMarriageDoc() {
            this.v$.$validate();

            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });

                if (this.responseCode === 200) {

                    this.docRequests.totalRequests++;
                    this.docRequests.requestNo++;
                    this.docsCount++;

                    this.reset();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // go to previous document
        async previousDoc() {
            this.v$.$validate();

            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store
                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });

                if (this.responseCode === 200) {
                    this.reset();

                    if (this.docRequests.requestNo > 1) {
                        this.docRequests.requestNo--;
                        this.docsCount--;
                    }

                    this.fillData();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // go to next document
        async nextDoc() {
            this.v$.$validate();

            if (!this.v$.$error) {
                this.saveDocument(); // save form data first in the store

                await sharedMethods.PreviewDoc(this.DocData, this.options).then(res => { this.responseCode = res.responseCode; this.responseMessage = res.responseMessage; });

                if (this.responseCode === 200) {

                    this.reset();

                    if (this.docRequests.requestNo < this.docRequests.totalRequests) {
                        this.docRequests.requestNo++;
                        this.docsCount++;
                    }
                    this.fillData();
                } else {
                    this.$alerts.toast.error(this.responseMessage);
                }
            } else {
                this.$alerts.toast.error('هناك خطأ فى البيانات المدخلة');
            }
        },

        // Delete document
        deleteDocument() {

            if (this.docRequests.requestNo > 1) {
                this.deleteDoc(this.docRequests.requestNo);
                this.docRequests.totalRequests--;
                this.docRequests.requestNo--;
                this.docsCount--;
            }

            this.fillData();
        },

        //auto fill for testing
        AutoFill() {
            this.form.firstName = "تسنيم";
            this.form.secondName = "سمير";
            this.form.thirdName = "محمد";
            this.form.fourthName = "شحاتة";
            this.form.motherName = "ماما";
            this.form.nid = "29709011235741";
            this.form.spouseName = 'xxxxxx';
            this.copies = 1;

        },

        // fill data in the form in case of already existing docs
        fillData() {

            if (this.MarriageDocs[this.docRequests.requestNo]) {

                let fullname = (this.MarriageDocs[this.docRequests.requestNo]).name.fullName.split(' ')

                this.form.firstName = fullname[0];
                this.form.secondName = fullname[1];
                this.form.thirdName = fullname[2];
                this.form.fourthName = fullname[3];
                this.gender = (this.MarriageDocs[this.docRequests.requestNo]).genderCode;
                this.form.motherName = (this.MarriageDocs[this.docRequests.requestNo]).motherFullName;
                this.form.nid = (this.MarriageDocs[this.docRequests.requestNo]).nid.nationalIdenNumber;
                this.form.relationCode = (this.MarriageDocs[this.docRequests.requestNo]).relationCode;
                this.form.spouseName = (this.MarriageDocs[this.docRequests.requestNo]).spouseFullName;
                this.copies = (this.MarriageDocs[this.docRequests.requestNo]).numberOfCopies;

            }

        },

        // assign data to variables and save it to the store
        saveDocument() {
            let docData = {
                "numberOfCopies": parseInt(this.copies),
                "name": { "fullName": this.form.firstName + ' ' + this.form.secondName + ' ' + this.form.thirdName + ' ' + this.form.fourthName },
                "motherFullName": this.form.motherName,
                "spouseFullName": this.form.spouseName,
                "nid": { "nationalIdenNumber": this.form.nid },
                "genderCode": this.gender,
                "relationCode": this.form.relationCode
            }
            let savedata = {
                "reqNo": this.docRequests.requestNo,
                "document": docData,
            }


            this.saveDocs(savedata);  // store action for saving Documents

        },

        // empty form data to fill new one
        reset() {
            this.form = {};
            this.copies = 1;
            this.gender = '',
                this.relation_lookups = [],
                this.checked = false;
            this.v$.$reset();
        }
    }
}
</script>